export const tags = [
  "adjust-grade-modal",
  "grade-by-question",
  "grade-by-student",
  "jnct-gradebook-custom-column",
  "gradebook-dropdown",
  "gradebook-grade-editor",
  "gradebook-instructor",
  "gradebook-student",
  "grading-board",
  "grading-center",
  "filter-modal",
  "grading-center-learnosity-feedback-modal",
  "grading-center-modal",
  "grading-header",
  "grading-input",
  "learnosity-item",
  "override-assessment-modal",
  "give-max-modal",
  "jnct-sort",
] as const;
